import React from 'react';
import { CardCvcElement, CardElement, CardExpiryElement, CardNumberElement } from '@stripe/react-stripe-js';
import './Payment.css'
import { useState } from 'react';
import { InputText } from 'primereact/inputtext';
import './Payment.css'
const CARD_NUMBER_OPTIONS = {
    placeholder: 'номер карты',
    hidePostalCode: true,
    style: {
        base: {
            color: "#495057",
            fontFamily: '"Gilroy", Helvetica, sans-serif',
            fontSmoothing: "antialiased",
            fontSize: "16px",
            padding: "20px",
            "::placeholder": {
                color: "#6c757d",
            },
        },
        invalid: {
            color: "#fa755a",
            iconColor: "#fa755a",
        },
    },
};

const CARD_EXPIRY_OPTIONS = {
    placeholder: 'дата',
    style: {
        base: {
            color: "#495057",
            fontFamily: '"Gilroy", Helvetica, sans-serif',
            fontSmoothing: "antialiased",
            fontSize: "16px",
            padding: "20px",
            "::placeholder": {
                color: "#6c757d",
            },
        },
        invalid: {
            color: "#fa755a",
            iconColor: "#fa755a",
        },
    },
};

const CARD_CVC_OPTIONS = {
    placeholder: 'cvc/cvv',
    style: {
        base: {
            color: "#495057",
            fontFamily: '"Gilroy", sans-serif',
            fontSmoothing: "antialiased",
            fontSize: "1rem",
            padding: "20px",
            "::placeholder": {
                color: "#6c757d",

            },
        },
        invalid: {
            color: "#fa755a",
            iconColor: "#fa755a",
        },
    },
};



function CardSection({ errorMessage }) {
    const [nameUserCard, setNameUserCard] = useState('')
    return (
        <label>
            {/*  <h5 className="select-title my-3">Введите данные для оплаты</h5>
            <CardNumberElement options={CARD_NUMBER_OPTIONS} />
            <div className="payment-form-block">
                <CardExpiryElement options={CARD_EXPIRY_OPTIONS} />
                <CardCvcElement options={CARD_CVC_OPTIONS} />

            </div> */}

            <CardElement options={CARD_NUMBER_OPTIONS} />
            {errorMessage &&
                <div style={{ color: '#fa755a' }}>{errorMessage}</div>}
        </label>
    );
};
export default CardSection;